// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"417":"f1583b38","559":"626b9d59","732":"b964b815","977":"8975094b"}[chunkId] + ".chunk.js";
};